// 分類列表、搜尋列表、編輯作者列表 - 側邊廣告欄位

import Image from 'next/image';

const ListAsideAd = ({ position, banners }) => {
    if (banners?.img)
        return (
            <a
                href={banners?.link}
                target="_blank"
                rel="noreferrer noopener"
                id="list-ad"
                className={`gtm-banner-H02 skelton flex-shrink-0 img-box aspect-[276/560] block rounded-[12px] overflow-hidden
                ${position === 'news' ? 'w-full' : 'w-[276px]'} uxl:hidden`}
            >
                <Image
                    width={276}
                    height={560}
                    src={banners?.img}
                    alt={banners?.alt}
                    sizes="220px"
                />
            </a>
        );

    return <span id="list-ad" />;
};

export default ListAsideAd;
